var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedigera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17.2501V21.0001H7.25L18.31 9.94006L14.56 6.19006L3.5 17.2501ZM21.21 7.04006C21.6 6.65006 21.6 6.02006 21.21 5.63006L18.87 3.29006C18.48 2.90006 17.85 2.90006 17.46 3.29006L15.63 5.12006L19.38 8.87006L21.21 7.04006Z",
    fill: "#3949AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedigera);
export default __webpack_public_path__ + "static/media/redigera.fc57a85dfd54fcbcc81c052317fc9fbc.svg";
export { ForwardRef as ReactComponent };